var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6.047 12.846c7.148 7.226 10.596 2.02 10.596 2.02.081-.137.018-.329-.089-.447l-3.01-3.008a.65.65 0 0 0-.904-.01l-.008.001-1.051 1.061c-.354.329-.734.064-1.028-.103 0 0-.918-.539-2.15-1.833l-.004-.004-.004-.004c-.036-.034-.957-.954-.992-.987-1.217-1.18-1.726-2.048-1.726-2.048-.166-.293-.432-.674-.103-1.027l1.024-1.089.003-.008a.65.65 0 0 0-.01-.903L3.58 1.446c-.118-.107-.31-.17-.447-.089 0 0-5.173 3.426 1.953 10.529l.952.952z"
})));
export default SvgPhone;